import 'babel-polyfill';
import 'core-js/es6/map';
import 'core-js/es6/set';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as qs from "qs";
import { initTheme } from '../src/services/theme';
import ErrorBoundary from './components/ErrorBoundary';
import * as Components from "./components";
require("./polyfill");

initTheme();

function hydrate( node ) {
  Object.keys(Components).forEach( (k) => {
    const els = node.getElementsByTagName(k);
    if (els.length) {
      Array.from(els).forEach( (_el: Element) => {
        const el = (_el as HTMLElement);
        let _props = {};
        if (el.dataset && el.dataset.props) {
          // direct mode (data-props)
          _props = JSON.parse(el.dataset.props);
        } else {
          // single prop mode (data-vattelapesca)
          const dset = el.dataset;
          Object.keys(dset).forEach( k => {
            try {
              _props[k] = JSON.parse(dset[k] as string);
            } catch(e) {
              // if not json, direct fill
              _props[k] = dset[k];
              //console.log('error JSON parse', k, 'on', el, dset[k]);
            }
          });
        }
        var props = {};
        Object.keys(_props).forEach( k => {
            var prop  = _props[k];
            // transformations server => client
            if (typeof prop === "string" && prop.indexOf('redirect:') !== -1) {
              let url = prop.substring( 'redirect:'.length );
              prop = (args) => {
                const query = qs.stringify(args)
                url += ((url.indexOf('?') === -1) ? '?' : '&') + query;
                self.location.href = url;
              }
            }
            
            // assign
            props[k] = prop;
          
        });
        const children = (el as HTMLElement).innerHTML;
        const Component = Components[k];
  
        ReactDOM.render(
          <ErrorBoundary><Component {...props}><div dangerouslySetInnerHTML={{__html: children}} /></Component></ErrorBoundary>,
          el as HTMLElement
        );
      });
    }
  });
}

hydrate( document );



// WEBPACK FOOTER //
// ./src/index.tsx